const ERROR_BASE_URL = 'https://pix.bcb.gov.br/api/v2/error';

const COMMON = {
  OK: {
    status: 200
  },
  CREATED: {
    status: 201
  },
  ACCEPTED: {
    status: 202
  },
  INVALID_REQUEST: {
    type: `${ERROR_BASE_URL}/RequisicaoInvalida`,
    title: 'Requisição inválida',
    detail: 'Requisição inválida',
    status: 400
  },
  FORBIDDEN: {
    type: `${ERROR_BASE_URL}/AcessoNegado`,
    title: 'Acesso Negado',
    detail: 'Requisição de participante autenticado que viola alguma regra de autorização.',
    status: 403
  },
  NOT_FOUND: {
    type: `${ERROR_BASE_URL}/NaoEncontrado`,
    title: 'Não encontrado',
    detail: 'Entidade não encontrada.',
    status: 404
  },
  PERMANENTLY_REMOVED: {
    type: `${ERROR_BASE_URL}/PermanentementeRemovido`,
    title: 'Recurso removido permanentemente',
    detail: 'Recurso removido permanentemente',
    status: 410
  },
  INTERNAL_SERVER_ERROR: {
    type: `${ERROR_BASE_URL}/ErroInternoDoServidor`,
    title: 'Erro interno do servidor',
    detail: 'Ocorreu um erro interno do servidor ao processar a requisição.',
    status: 500
  },
  UNAVAILABLE: {
    type: `${ERROR_BASE_URL}/ServicoIndisponivel`,
    title: 'Serviço Indisponível',
    detail:
      'Serviço não está disponível no momento. Serviço solicitado pode estar em manutenção ou fora da janela de funcionamento.',
    status: 503
  },
  GATEWAY_TIMEOUT: {
    type: `${ERROR_BASE_URL}/IndisponibilidadePorTempoEsgotado`,
    title: 'Indisponibilidade por tempo esgotado',
    detail: 'Servidor demorou além do tempo esperado para retornar uma resposta.',
    status: 504
  }
};

const COB_LOCATION = {
  NOT_FOUND: {
    ...COMMON.NOT_FOUND,
    type: `${ERROR_BASE_URL}/CobPayloadNaoEncontrado`,
    detail: 'A cobrança em questão não foi encontrada para a location requisitada.'
  },
  INVALID_REQUEST: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/CobPayloadOperacaoInvalida`,
    detail: 'A cobrança em questão não foi encontrada para a location requisitada.'
  }
};

const COB = {
  TXID_NOT_FOUND: {
    ...COMMON.NOT_FOUND,
    type: `${ERROR_BASE_URL}/CobNaoEncontrado`,
    detail: 'A cobrança em questão não foi encontrada para o txid requisitado.'
  },
  INVALID_OPERATION_REQUEST: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/CobOperacaoInvalida`,
    detail:
      'A requisição que busca alterar ou criar uma cobrança para pagamento imediato não respeita o schema ou está semanticamente errada.'
  },
  INVALID_QUERY_REQUEST: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/CobConsultaInvalida`,
    detail:
      'Os parâmetros de consulta de cobranças para pagamento imediato não respeitam o schema ou não fazem sentido semanticamente.'
  }
};

const COBV = {
  TXID_NOT_FOUND: {
    ...COMMON.NOT_FOUND,
    type: `${ERROR_BASE_URL}/CobVNaoEncontrada`,
    detail: 'A cobrança em questão não foi encontrada para o txid requisitado.'
  },
  INVALID_OPERATION_REQUEST: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/CobVOperacaoInvalida`,
    detail:
      'A requisição que busca alterar ou criar uma cobrança com vencimento não respeita o schema ou está semanticamente errada.'
  },
  INVALID_QUERY_REQUEST: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/CobVConsultaInvalida`,
    detail:
      'Os parâmetros de consulta de cobranças com vencimento não respeitam o schema ou não fazem sentido semanticamente.'
  }
};

const PIX = {
  E2EID_NOT_FOUND: {
    ...COMMON.NOT_FOUND,
    type: `${ERROR_BASE_URL}/PixNaoEncontrado`,
    detail: 'Pix não encontrada para o e2eid informado.'
  },
  CHARGEBACK_NOT_FOUND: {
    ...COMMON.NOT_FOUND,
    type: `${ERROR_BASE_URL}/PixDevolucaoNaoEncontrada`,
    detail: 'Devolução representada por {id} não encontrada para o e2eid informado.'
  },
  INVALID_QUERY_REQUEST: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/PixConsultaInvalida`,
    detail:
      'Os parâmetros de consulta à lista de pix recebidos não respeitam o schema ou não fazem sentido semanticamente.'
  },
  INVALID_CHARGEBACK: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/PixDevolucaoInvalida`,
    detail: 'A presente requisição de devolução não respeita o schema ou não faz sentido semanticamente.'
  },
  CHARGEBACK_EXCEEDS_VALUE: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/PixDevolucaoInvalida`,
    detail: 'Valor das devoluções maior que valor do PIX recebido.'
  },
  INSUFFICIENT_BALANCE: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/PixDevolucaoInvalida`,
    detail: 'Saldo insuficiente.'
  },
  CHARGEBACK_DEADLINE_EXCEEDED: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/PixDevolucaoInvalida`,
    detail: 'PIX Recebido a mais de 90 dias, não é possível fazer devolução.'
  },
  CHARGEBACK_DUPLICATED: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/PixDevolucaoInvalida`,
    detail: 'O id de devolução enviado já existe.'
  }
};

const WEBHOOK = {
  INVALID_OPERATION_REQUEST: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/WebhookOperacaoInvalida`,
    detail:
      'A presente requisição busca criar um webhook sem respeitar o schema ou, ainda, com sentido semanticamente inválido.'
  },
  NOT_FOUND: {
    ...COMMON.NOT_FOUND,
    type: `${ERROR_BASE_URL}/WebhookNaoEncontrado`,
    detail: 'O webhook denotado por {chave} não encontra-se estabelecido.'
  },
  INVALID_QUERY_REQUEST: {
    ...COMMON.INVALID_REQUEST,
    type: `${ERROR_BASE_URL}/WebhookConsultaInvalida`,
    detail:
      'Os parâmetros de consulta à lista de webhooks ativados não respeitam o schema ou não fazem sentido semanticamente.'
  }
};

module.exports = {
  ERROR_BASE_URL,
  ...COMMON,
  COB_LOCATION,
  COB,
  COBV,
  PIX,
  WEBHOOK
};
